import { Input } from '../Common/Input';
import type { AdditionalInputField } from '@/types/checkout';
import { Email } from '../Common/Email';
import { AdyenInputType } from '@/types/adyen';
import { PayButton } from '../PaymentInputs/PayButton';
import { UnmanagedAddress } from '../Address/UnmanagedAddress';
import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';

interface AdyenPayFormUIProps {
  additionalInputFields: AdditionalInputField[];
  fieldValues: Record<string, string>;
  fieldErrors: Record<string, string>;
  totalPrice: string;
  onFieldChange: (field: AdditionalInputField, value: string) => void;
  onFieldBlur: (field: AdditionalInputField, value: string) => void;
  onPayment: () => void;
  isDisabled?: boolean;
  handleTaxValidationChange: (isValid: boolean) => void;
}

export const AdyenPayFormUI = ({
  additionalInputFields,
  fieldValues,
  fieldErrors,
  totalPrice,
  onFieldChange,
  onFieldBlur,
  onPayment,
  isDisabled = false,
  handleTaxValidationChange,
}: AdyenPayFormUIProps) => {
  const renderFieldInput = (field: AdditionalInputField) => {
    const value = fieldValues[field.apm_key] || '';
    switch (field.apm_key) {
      case AdyenInputType.SHOPPER_EMAIL:
      case AdyenInputType.EMAIL:
        return <Email />;

      case AdyenInputType.SHOPPER_NAME:
        return (
          <Input
            {...field}
            className="w-full"
            placeholder={field.display_name}
            value={value}
            onChange={(e) => onFieldChange(field, e.target.value)}
            onBlur={() => onFieldBlur(field, value)}
          />
        );

      case AdyenInputType.BILLING_ADDRESS:
        return (
          <>
            <UnmanagedAddress value={value} onChange={(newValue) => onFieldChange(field, newValue)} />
          </>
        );

      case AdyenInputType.TELEPHONE_NUMBER:
        return (
          <Input
            {...field}
            className="w-full"
            placeholder={field.display_name}
            value={value}
            onChange={(e) => onFieldChange(field, e.target.value)}
            onBlur={() => onFieldBlur(field, value)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col gap-4">
      {additionalInputFields.map((field: AdditionalInputField) => {
        const error = fieldErrors[field.apm_key];

        return (
          <div key={field.apm_key} className="flex flex-col gap-1 w-full">
            {renderFieldInput(field)}
            {error && <div className="text-xs p-1 text-red-500">{error}</div>}
          </div>
        );
      })}
      <InputTaxComponent onValidate={handleTaxValidationChange} />
      <PayButton onClick={onPayment} price={totalPrice} isDisabled={isDisabled} />
    </div>
  );
};
